'use client';

import PharmacySearch from './PharmacySearch';
import PharmacySavedList from './PharmacySavedList';
import { ComponentFields } from 'types/content';
import { useAppSelector } from 'lib/hooks';
import { selectPharmacies } from 'slices/pharmacySlice';
import CheckCircleIcon from 'components/icons/CheckCircleIcon';
import { useEffect, useRef } from 'react';
import { ANALYTICS_EVENTS, capture, secondsSince } from 'lib/analytics';

const PharmacyForm = ({ data, onContinue }: ComponentFields) => {
  const savedPharmacies = useAppSelector(selectPharmacies);
  const mountTimeRef = useRef<number | null>(null);
  useEffect(() => {
    mountTimeRef.current = Date.now();
    capture(ANALYTICS_EVENTS.pharmacyFormViewed);
  }, []);

  const title = data.elements.title.value;
  const subtitle = data.elements.subtitle.value;
  const continueEmpty = data.elements.continueTextEmpty.value;
  const continuePopulated = data.elements.continueTextPopulated.value;

  const handleContinue = () => {
    capture(ANALYTICS_EVENTS.pharmacyFormCompleted, {
      duration_seconds: secondsSince(mountTimeRef.current),
    });
    onContinue();
  };

  return (
    <section className="form-container large">
      <PharmacySearch title={title} subtitle={subtitle} />
      <PharmacySavedList pharmacies={savedPharmacies} />
      <button
        className={`button ${
          savedPharmacies.length === 0 ? 'secondary' : 'primary checked'
        }`}
        onClick={handleContinue}
      >
        {savedPharmacies.length === 0 ? continueEmpty : continuePopulated}
        {savedPharmacies.length > 0 && <CheckCircleIcon color="white" />}
      </button>
    </section>
  );
};

export default PharmacyForm;
